import { createFileRoute } from '@tanstack/react-router';
import { Outlet } from '@/lib/router-components';

export const Route = createFileRoute('/w/$workspaceId/workflow-presets')({
  component: WorkflowPresetsLayout,
});

function WorkflowPresetsLayout() {
  return <Outlet />;
}

